// common configuration
const config = {
    api: {
        baseUrl: "https://lidl.gatehouse.mmsecurity.cz/api"
    },
    afterLoginRoute: "dashboard",
    vueAppUrl: "https://lidl.gatehouse.mmsecurity.cz"
};

if (import.meta.env.VITE_VUE_APP_SERVER == "production") {
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_matej") {
    config["vueAppUrl"] = "http://localhost:9000";
    config["api"]["baseUrl"] = "http://localhost:9001";
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_kuba") {
    config["vueAppUrl"] = "http://localhost:20201";
    config["api"]["baseUrl"] = "http://localhost:20200";
}
else if (import.meta.env.VITE_VUE_APP_SERVER == "dev_tomas") {
    config["vueAppUrl"] = "http://localhost:36011";
    config["api"]["baseUrl"] = "http://localhost:36010";
}

export const CONFIG = config;